import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet'
import { MatListModule } from '@angular/material/list'
import { RecycledContent } from '../../../../types/products'
import { MatDivider } from '@angular/material/divider'
import { Router } from '@angular/router'
import { TranslationService } from '../../../../services/translation.service'

@Component({
  selector: 'app-recycled-content-sheet',
  imports: [MatListModule, MatDivider],
  templateUrl: './recycled-content-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './recycled-content-sheet.component.scss',
})
export class RecycledContentSheetComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA)
  router = inject(Router)
  translationService = inject(TranslationService)

  private _bottomSheetRef =
    inject<MatBottomSheetRef<RecycledContentSheetComponent>>(MatBottomSheetRef)

  recycledContent: Array<RecycledContent> = []

  // the object injected below has to be any since 'data' is dynamic

  constructor() {
    const data = this.data

    if (data.recycledContent) {
      this.recycledContent = data.recycledContent
    }
  }

  /**
   * Navigates to a product's overview screen
   * @param {MouseEvent | KeyboardEvent} event Event that occurs due to interacting with a pointing device or keyboard
   * @param {string} id  Id of the component
   */
  goToProductOverview(event: MouseEvent | KeyboardEvent, id: string): void {
    this._bottomSheetRef.dismiss()
    event.preventDefault()
    this.router.navigate([`/products/${id}/overview`])
  }

  /**
   * Handles the `keydown` event for keyboard navigation.
   * Allows navigating the list using arrow keys and selecting items with Enter.
   *
   * @param {KeyboardEvent} event - The keyboard event triggered when a key is pressed down.
   * @param {number} index - The current index of the focused list item.
   */
  onKeydown(event: KeyboardEvent, index: number): void {
    const listItems = document.querySelectorAll('a[mat-list-item]')

    if (event.key === 'ArrowDown') {
      // Prevent default scroll behavior
      event.preventDefault()

      // Focus the next item, if it exists
      if (index < listItems.length - 1)
        (listItems[index + 1] as HTMLElement).focus()
    } else if (event.key === 'ArrowUp') {
      // Prevent default scroll behavior
      event.preventDefault()

      // If the current index is greater than 0, focus on the previous item
      if (index > 0) (listItems[index - 1] as HTMLElement).focus()
    } else if (event.key === 'Enter') {
      // Call the navigation method on Enter
      this.goToProductOverview(event, this.recycledContent[index].id)
    }
  }
}
